export interface IStorage {
    setItem<T>(key: string, data: T): Promise<void>;
    getItem<T>(key: string): Promise<T | null>;
    removeItem(key: string): Promise<void>;
}

export  class LocalStorage implements IStorage {
    private baseKey: string;
    constructor(baseKey: string) {
        this.baseKey = baseKey;
    }

    public setItem = async <T>(key: string, data: T) => {
        if (!this.checkStorage()) {
            throw new Error('localstorage not found');
        }
        window.localStorage.setItem(`${this.baseKey}/${key}`, JSON.stringify(data));
    }
    public getItem = async <T>(key: string) => {
        if (!this.checkStorage()) {
            throw new Error('localstorage not found');
        }
        const value = window.localStorage.getItem(`${this.baseKey}/${key}`);
        if (!value) {
            return null;
        } else {
            return JSON.parse(value) as T;
        }
    }
    public removeItem = async (key: string) => {
        if (!this.checkStorage()) {
            throw new Error('localstorage not found');
        }
        window.localStorage.removeItem(`${this.baseKey}/${key}`);
    }

    private checkStorage(): boolean {
        return !!window.localStorage;
    }

}
